export default __webpack_public_path__ + "static/katrina-yentch-7063b4f67c79f12d37d9d0e8253e2654.jpeg";